const progressWrapper = document.getElementById("progress");
const progressContainer = document.getElementById("progress-container");
const progressBar = document.getElementById("progress-bar");
const body = document.getElementById("html-body");
const main = document.querySelector(".main");
const content = progressWrapper ? document.getElementById("content").querySelector(".bodytext")
  .parentElement : null;
const scrollProgress = document.getElementById("scroll-progress");
const desc = document.querySelector(".progress-title");
const dot = progressWrapper ? progressWrapper.querySelector(".progress-dot") : null;
const hide = document.querySelector('#content').classList.contains('no-scrollindicator')

if (progressBar) {

  progressBar.style.minWidth = "2.25rem";

  window.onscroll = (e) => {
    scrollIndicator();
  };

  window.onload = (e) => {
    showHideProgress(hide);
  };

  window.onresize = (e) => {
    showHideProgress(hide);
  };
}

function scrollIndicator() {
  var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
  var footerHeight = body.clientHeight - main.clientHeight;

  var height =
    document.documentElement.scrollHeight -
    document.documentElement.clientHeight;

  var scrolled = (winScroll / (height - footerHeight)) * 100;
  if (scrolled > 100) scrolled = 100;
  if (scrolled < 0) scrolled = 0;

  var barWidth = scrolled;
  var position = 0;
  var widthTurningPoint = 97;
  var positionTurningPoint = 97;
  var minWidth = "2.25rem";

  if (scrolled > positionTurningPoint) {
    barWidth = positionTurningPoint;
    position = 100 - ((100 - scrolled) * 100) / (100 - positionTurningPoint);
  } else if (scrolled == 100) {
    position = 100;
    minWidth = "3rem";
  }

  if (scrolled > widthTurningPoint) {
    barWidth =
      widthTurningPoint -
      ((scrolled - widthTurningPoint) * widthTurningPoint) /
        (100 - widthTurningPoint);

    if (barWidth > positionTurningPoint) barWidth = positionTurningPoint;
    minWidth = "3rem";
  }

  if (position + barWidth > 100) {
    barWidth = 100 - position;
  }

  if (scrolled >= 0 && scrolled <= 100) {
    progressBar.style.width = barWidth + "%";
    progressBar.style.left = position + "%";
    progressBar.style.minWidth = minWidth;
    scrollProgress.innerText = Math.round(scrolled);
  }
  if (scrolled == 100) {
    dot.style.height = "3.5rem";
    dot.style.width = "3.5rem";
    dot.style.right = "-0.25rem";
    dot.style.borderRadius = "50%";
    dot.style.opacity = 1;
    dot.style.transitionDelay = "";
  } else {
    dot.style.transitionDuration = "0s";
    dot.style.transitionDelay = "0s";
    dot.style.height = "";
    dot.style.width = "";
    dot.style.opacity = 0;
  }

  if (barWidth > 0 && (progressContainer.clientWidth * barWidth) / 100 > 130) {
    desc.style.transition = "opacity 0.8s";
    desc.style.opacity = 1;
  } else {
    desc.style.transition = "";
    desc.style.opacity = "";
  }
}

export function showHideProgress(hide = false) {
  if (hide) return;
  if (content.clientHeight + 80 <= document.documentElement.clientHeight) {
    progressWrapper.style.opacity = 0;
  } else {
    progressWrapper.style.opacity = 1;
  }
}